<div class="app-frame mat-app-background" [class.public-page-frame]="publicPage">
  <ng-container *ngIf="publicPage; else accountShell">
    <router-outlet></router-outlet>
  </ng-container>
  <ng-template #accountShell>
    <app-nav></app-nav>
  </ng-template>
</div>
